import React from 'react'
import { Mutation } from "react-apollo";
import Form from "../components/form";
import { EDIT, GET } from "../../../queries/layout_definition";

const Update = (props) => {
  return (
    <Mutation
      mutation={EDIT}
      update={(cache, { data: { updateLayoutDefinition } }) => {
        const { layoutdefinition } = cache.readQuery({ query: GET });
        cache.writeQuery({
          query: GET,
          data: { layoutdefinition: layoutdefinition }
        });
      }}
      >
      {updateLayoutDefinition => (
        <Form query_f = {updateLayoutDefinition} {...props} />
      )}
    </Mutation>
  );
};

export default Update;